module.exports = "<icon>view_quilt</icon> {{ getSchemaName() }}\n"